import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import {
  ActiveOrRequestedBookingStates,
  CatalogItem,
  OfferedOrRequestedPriceRequestStates,
} from '@markant-platform/cartridge/model';

@Pipe({
  name: 'serviceCartridgeStatus',
  standalone: true,
})
export class ServiceCartridgeStatePipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  transform(catalogItem: CatalogItem): string {
    if (!catalogItem.isServiceGroup && catalogItem.serviceCartridgeGroup) {
      const { state, priceRequestState, variants } = catalogItem.serviceCartridgeGroup;

      if (state && ActiveOrRequestedBookingStates.includes(state)) {
        return this.translocoService.translate(`catalog.bookingState.${state}`);
      } else if (priceRequestState && OfferedOrRequestedPriceRequestStates.includes(priceRequestState)) {
        return this.translocoService.translate(`catalog.priceRequestState.${priceRequestState}`);
      } else if (variants.every(variant => !variant.allowUiBooking)) {
        return this.translocoService.translate('catalog.notUiBookable.TRUE');
      }
    }

    return '';
  }
}
